/**
 * EventGallery — 대회 갤러리 (히어로 아래). 현장 실적 사진으로 증명.
 * 문구는 copy.js(GALLERY)에서 가져옴. 하드코딩 0.
 */
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/EventGallery.module.css';
import { GALLERY } from './copy';
// 실제 이미지 로딩(Vite import). copy.js images[].file은 기록용 문자열 → 아래 맵의 키로 사용.
import award1 from '../../assets/images/IMG_20260603_163851.jpg';
import award2 from '../../assets/images/IMG_20260603_175726.jpg';
import award3 from '../../assets/images/IMG_20260603_175732.jpg';

// copy.js의 file 문자열 → Vite import 값 매핑(순서 의존 X)
const GALLERY_IMAGES = {
  'src/assets/images/IMG_20260603_163851.jpg': award1,
  'src/assets/images/IMG_20260603_175726.jpg': award2,
  'src/assets/images/IMG_20260603_175732.jpg': award3,
};

export default function EventGallery() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="gallery" ref={ref} className={`section ${styles.gallery} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.inner}>
        <h2 className={styles.headline}>{GALLERY.headline}</h2>
        {GALLERY.subcopy && <p className={styles.subcopy}>{GALLERY.subcopy}</p>}

        <div className={styles.grid}>
          {GALLERY.images.map((image) => (
            <figure key={image.file} className={styles.item}>
              <img
                className={styles.image}
                src={GALLERY_IMAGES[image.file]}
                alt={image.alt}
                loading="lazy"
              />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
